import React, { useMemo, Fragment } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';

import StatusBadge from 'components/StatusBadge';
import Table from 'components/Table';
import { transfersTable as TEXT } from 'locales/en/transfer';

const TransferTable = ({ data, title, isDetail, ...rest }) => {
  const GRID_CLASSNAME = useMemo(() => {
    return isDetail ? 'grid-transfers' : 'grid-transfers-index';
  }, [isDetail]);

  const TITLES = useMemo(() => {
    let _titles = [
      TEXT.created_at,
      TEXT.reference,
      TEXT.status,
      { name: TEXT.amount, class: 'text-center' },
      TEXT.source,
      TEXT.destination,
      { name: TEXT.attempt, class: 'text-center' },
      { name: TEXT.maxAttempts, class: 'text-center' },
    ];
    if (!isDetail) {
      _titles = [..._titles, ''];
    }
    return _titles;
  }, [isDetail]);

  return (
    <>
      {title && (
        <h2 className="text-javelin-gray-dark lg:text-xl text-base font-bold mb-5">
          {title}
        </h2>
      )}
      <Table
        titles={TITLES}
        hasData={!!data.length}
        gridClassName={GRID_CLASSNAME}
        {...rest}
      >
        {data.map((item, idx) => {
          const dataIndexNumber = data.length - 1 === idx ? 'last' : idx;

          return (
            <Fragment key={item.id}>
              <span
                data-index-number={dataIndexNumber}
                className="text-javelin-gray-dark text-xs py-3 px-5"
              >
                {format(new Date(item.created_at), 'd MMM')}
              </span>
              <span
                data-index-number={dataIndexNumber}
                className="text-javelin-gray-dark text-xs py-3 px-5"
              >
                {item.reference}
              </span>
              <span
                data-index-number={dataIndexNumber}
                className="text-javelin-gray-dark text-xs py-3 pl-5"
              >
                <StatusBadge status={item.status} className="ml-0" />
              </span>
              <span
                data-index-number={dataIndexNumber}
                className="text-javelin-gray-dark text-xs py-3 px-5 text-center"
              >
                {item.amountToDisplay}
              </span>
              <span
                data-index-number={dataIndexNumber}
                className="text-javelin-gray-dark text-xs py-3 px-5"
              >
                {item.source_account_code}
              </span>
              <span
                data-index-number={dataIndexNumber}
                className="text-javelin-gray-dark text-xs py-3 px-5"
              >
                {item.destination_account_code}
              </span>
              <span
                data-index-number={dataIndexNumber}
                className="text-javelin-gray-dark text-xs py-3 px-5 text-center"
              >
                {item.attempt}
              </span>
              <span
                data-index-number={dataIndexNumber}
                className="text-javelin-gray-dark text-xs py-3 px-5 text-center"
              >
                {item.max_attempts}
              </span>
              {!isDetail && (
                <Link
                  data-index-number={dataIndexNumber}
                  className="text-javelin-gray-light text-xs py-3 px-5 text-right cursor-pointer hover:text-javelin-gray-dark"
                  to={`/transfers/${item.id}`}
                >
                  <FontAwesomeIcon
                    icon={['far', 'eye']}
                    className="fill-current my-auto"
                  />
                </Link>
              )}
            </Fragment>
          );
        })}
      </Table>
    </>
  );
};

TransferTable.propTypes = {
  data: PropTypes.array,
  title: PropTypes.string,
  isDetail: PropTypes.bool,
};
TransferTable.defaultProps = {
  data: [],
  title: TEXT.title,
};
export default TransferTable;
